import {boundMethod} from "autobind-decorator";
import {isEqual} from "lodash";

import EventHandlers from "@/services/handlers";
import http from "@/services/http";
import {ICentSample} from "@cent/analysis/models";
import {ICentSampleNameDetails} from "@cent/analysis/services/models";

interface IEventHandler {
    updateSampleNameDetails(
        sample: ICentSample,
        sampleDetails: ICentSampleNameDetails,
    ): void;
}

class SampleDetailsService {
    private readonly events = new EventHandlers<IEventHandler>();
    private _sampleDetails = new Map<ICentSample, ICentSampleNameDetails>();

    public get sampleDetails() {
        return this._sampleDetails;
    }

    @boundMethod
    public getBySampleId(sample: ICentSample, sendRequest: boolean = true) {
        const {measurement, position, optical} = sample;
        const model: ICentSample = {
            measurement,
            position,
            optical,
        };

        for (const [key, value] of this._sampleDetails) {
            if (isEqual(key, model)) {
                this.events.publish((x) =>
                    x.updateSampleNameDetails?.(model, value),
                );
                return;
            }
        }

        if (sendRequest) {
            this.retrieve(model);
        }
    }

    @boundMethod
    public async retrieve(sample: ICentSample) {
        try {
            const json: ICentSample = {
                measurement: sample.measurement,
                position: sample.position,
                optical: sample.optical,
            };

            const details = await http
                .post("/api/centrifuge/stats/sample_details", {
                    json,
                })
                .json<ICentSampleNameDetails>();

            this._sampleDetails.set(sample, details);
            this.events.publish((x) =>
                x.updateSampleNameDetails?.(sample, details),
            );
        } catch {
            return;
        }
    }

    public subscribe(handler: IEventHandler) {
        return this.events.register(handler);
    }
}

const sampleNameDetailsService = new SampleDetailsService();
export default sampleNameDetailsService;
